import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { SERVICES, type Service } from '../lib/services';
import { FullRow } from './FormDialog';

/** FCL / LCL / Air / Road tick boxes, for a FormDialog */
export const ServiceCheckboxes = ({ value, onChange }: { value: Service[]; onChange: (next: Service[]) => void }) => (
  <FullRow>
    <FormGroup row>
      {SERVICES.map((s) => (
        <FormControlLabel
          key={s}
          label={s}
          control={
            <Checkbox
              checked={value.includes(s)}
              onChange={(e) => onChange(e.target.checked ? [...value, s] : value.filter((x) => x !== s))}
            />
          }
        />
      ))}
    </FormGroup>
  </FullRow>
);
